var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TerminOverviewComp',{attrs:{"archived":false}}),(_vm.showNeuerTermin)?_c('v-btn',{staticClass:"buttonAdd",attrs:{"color":"success","to":'/raid/neuerTermin'}},[_vm._v("\n        Neuer Termin\n    ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }